/**
 * Safety net for unknown / future result_card shapes. Per spec §1, this
 * shouldn't fire in normal operation but prevents a backend tool ahead
 * of frontend support from crashing the chat.
 */
import React, { useState } from 'react';
import { Alert, AlertTitle, Box, Link, Typography } from '@mui/material';

interface UnknownResultFallbackProps {
  content: Record<string, unknown>;
}

export const UnknownResultFallback: React.FC<UnknownResultFallbackProps> = ({
  content,
}) => {
  const [expanded, setExpanded] = useState(false);
  return (
    <Alert severity="info" sx={{ '& .MuiAlert-message': { width: '100%' } }}>
      <AlertTitle sx={{ fontSize: 13, fontWeight: 600 }}>
        Result type not yet supported
      </AlertTitle>
      <Typography sx={{ fontSize: 13, color: 'text.secondary' }}>
        This card's renderer hasn't been built yet.{' '}
        <Link
          component="button"
          type="button"
          onClick={() => setExpanded((p) => !p)}
          sx={{ fontSize: 13 }}
        >
          {expanded ? 'Hide raw payload' : 'Show raw payload'}
        </Link>
      </Typography>
      {expanded ? (
        <Box
          component="pre"
          sx={{
            mt: 1,
            p: 1,
            bgcolor: 'background.paper',
            border: '1px solid',
            borderColor: 'grey.200',
            borderRadius: 0.5,
            fontSize: 12,
            overflow: 'auto',
            maxHeight: 240,
          }}
        >
          {JSON.stringify(content, null, 2)}
        </Box>
      ) : null}
    </Alert>
  );
};
